module.exports = __webpack_public_path__ + "img/numberplate.8e575143.svg";